import { mapStyleAtom } from '@/atoms';
import { getStatusColor } from '@/utils';
import { styles } from '@/utils/config';
import { useAtom } from 'jotai';
import { Layer, Source } from 'react-map-gl/maplibre';

export function IncidentsSource({ id, data, visibility = 'visible' }) {
  const [style] = useAtom(mapStyleAtom);
  const styleInfo = styles.find((item) => item.path === style);

  return (
    <Source id={id} type="geojson" data={data}>
      <Layer
        id={`${id}-shape-layer`}
        type="symbol"
        layout={{
          'icon-image': 'ir3-square',
          'icon-allow-overlap': true,
          'icon-size': ['interpolate', ['linear'], ['zoom'], 5, 0.125, 12, 1],
          visibility,
        }}
        paint={{
          'icon-color': [
            'match',
            ['get', 'status'],
            'opened',
            getStatusColor('opened'),
            'assigned',
            getStatusColor('assigned'),
            'attended',
            getStatusColor('attended'),
            'closed',
            getStatusColor('closed'),
            getStatusColor('default'),
          ],
          'icon-halo-color': '#fff',
          'icon-halo-width': 1,
        }}
      />
      <Layer
        id={`${id}-symbol-layer`}
        type="symbol"
        layout={{
          'text-field': ['get', 'grade'],
          'text-font': getFont(styleInfo?.source),
          'text-size': ['interpolate', ['linear'], ['zoom'], 5, 1.5, 12, 12],
          'text-allow-overlap': true,
          'text-anchor': 'center',
          'text-justify': 'center',
          visibility,
        }}
        paint={{
          'text-color': '#fff',
        }}
      />
    </Source>
  );
}

function getFont(source) {
  switch (source) {
    case 'OPENFREEMAP':
      return ['Noto Sans Bold'];
    case 'MAPTILER':
    case 'PROTOMAPS':
      return ['Roboto Bold'];
    default:
      return ['Arial Bold'];
  }
}
